import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_PATIENT_HISTORY_ADD, RQ_PATIENT_HISTORY_DELETE, RQ_PATIENT_HISTORY_LOOKUP, RQ_PATIENT_HISTORY_LOOKUP_ALL, RQ_PATIENT_HISTORY_UPDATE} from './Constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

export const RQAddPatientHistory = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_patient_history'],
    mutationFn: ({formData, token}) =>
      rqCreateRequest(
        RQ_PATIENT_HISTORY_ADD,
        formData,
        token,
        null,
      ),
    ...options,
  });

export const RQUpdatePatientHistory = (options = {}) =>
  useMutation({
    mutationKey: ['rq_update_patient_history'],
    mutationFn: ({id, formData, token}) =>
      rqCreateRequest(
        withUrl(RQ_PATIENT_HISTORY_UPDATE, 'id', id),
        formData,
        token,
        null,
      ),
    ...options,
  });

export const RQLookupPatientHistory = (
  patienthistoryId,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_patient_history', patienthistoryId],
    queryFn: () =>
      rqCreateRequest(
        withUrl(
          RQ_PATIENT_HISTORY_LOOKUP,
          'patienthistoryId',
          patienthistoryId,
        ),
        null,
        token,
        null,
      ).then(res => res ?? {}),
    enabled: !!patienthistoryId && !!token,
    ...options,
  });

export const RQLookupAllPatientHistory = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_all_patient_history'],
    queryFn: () =>
      rqCreateRequest(
        RQ_PATIENT_HISTORY_LOOKUP_ALL,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

export const RQDeletePatientHistory = (options = {}) =>
  useMutation({
    mutationKey: ['rq_delete_patient_history'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(
          RQ_PATIENT_HISTORY_DELETE,
          'id',
          id,
        ),
        null,
        token,
        null,
      ),
    ...options,
  });
